import type { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconProps } from "./Icon.d";

export const Icon: FC<IconProps> = props => <FontAwesomeIcon {...props} />;

export default Icon;